import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  CHANGE_STATUS_SURVEY_CONFIRM_DIALOG,
  changeStatusOfSurveyProperty,
  loadAvailableWorkflowTransition,
  NEW_SURVEY_STATUS,
  POSSIBLE_TRANSITIONS,
  setNewStatusWorkflowTransition,
  SHOW_CHANGE_STATUS_SURVEY_DIALOG,
  SHOW_SEND_SURVEY_DIALOG,
  TOTAL_PROGRESS
} from "../../../ducks/statusOfSurvey";
import StatusOfSurvey from "./StatusOfSurvey";
import { loadSurveyVersion } from "../../../ducks/survey";

const mapStateToProps = (state) => {
  return {
    showSendSurveyDialog: state.statusOfSurvey[SHOW_SEND_SURVEY_DIALOG],
    showChangeStatusSurveyDialog: state.statusOfSurvey[SHOW_CHANGE_STATUS_SURVEY_DIALOG],
    newSurveyStatus: state.statusOfSurvey[NEW_SURVEY_STATUS],
    changeStatusSurveyConfirmDialog: state.statusOfSurvey[CHANGE_STATUS_SURVEY_CONFIRM_DIALOG],
    possibleTransitions: state.statusOfSurvey[POSSIBLE_TRANSITIONS],
    totalProgress: state.statusOfSurvey[TOTAL_PROGRESS]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loadSurveyVersion,
      changeStatusOfSurveyProperty,
      loadAvailableWorkflowTransition,
      setNewStatusWorkflowTransition
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(StatusOfSurvey);
